// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import purchaseItemEntity from './entities/purchase-item.json';
import purchaseItemMenu from '../pages/purchase-item/menu.json';
import purchaseItemFullForm from '../pages/purchase-item/forms/full.json';
import purchaseItemContextForm from '../pages/purchase-item/forms/context.json';
import purchaseItemMiniForm from '../pages/purchase-item/forms/mini.json';
import purchaseItemLookupForm from '../pages/purchase-item/forms/lookup.json';
import purchaseItemTableView from '../pages/purchase-item/views/table.json';
import purchaseItemCardsView from '../pages/purchase-item/views/cards.json';
import purchaseItemDashboardView from '../pages/purchase-item/views/dashboard.json';

/** Тип запису «Предмет закупівлі» зі сторінками пакета: меню, форми та подання з pages/purchase-item/. */
export const purchaseItemDefinition: IRecordTypeDefinition = {
  ...purchaseItemEntity,
  views: assembleViewSet({
      table: purchaseItemTableView,
      cards: purchaseItemCardsView,
      dashboard: purchaseItemDashboardView,
  }),
  form: purchaseItemFullForm,
  forms: { full: purchaseItemFullForm, context: purchaseItemContextForm, mini: purchaseItemMiniForm, lookup: purchaseItemLookupForm },
  menu: purchaseItemMenu,
} as IRecordTypeDefinition;
